import { IDirectUpload } from "config";
import { fetchWithRetry } from "utils/fetchWithRetry";

const directUploadApi = {
  uploadFile: async (file: File, directUpload: IDirectUpload) => {
    const { headers, url } = directUpload;

    const options = {
      headers: JSON.parse(headers),
      method: "PUT",
      body: file,
    };

    return await fetchWithRetry(url, options, 2);
  },
};

export default directUploadApi;
